module.exports = __webpack_public_path__ + "img/levelup-icon-budget-document.735e3493.svg";